import React, { Fragment } from 'react';
import { Accordion } from 'react-bootstrap';
import '../../../../styles/itens.scss';


const Item = (props) => {
    return (
        <Fragment>
            <Accordion.Item eventKey="0">
                <Accordion.Header><strong>Serviço: {props.servico}</strong></Accordion.Header>
                <Accordion.Body>
                    <strong>Finalidade do Serviço</strong>: <br/>
                    {props.finalidade} <br/>
                    <strong>Requisitos Necessários para os Usuários</strong>: <br/>
                    {props.requisitos} <br/>
                    <strong>Etapas do Processo</strong>: <br/>
                    {props.etapas} <br/>
                    <strong>Tempo de Atendimento</strong>: <br/>
                    {props.tempo} <br/>
                    <strong>Local</strong>: <br/>
                    {props.local} <br/>
                </Accordion.Body>
            </Accordion.Item>
            <br/>
        </Fragment>
    );
}

export default Item;